import { Icon } from '@scale/scaleui';
import { useCurrentEditor } from '@tiptap/react';
import useIsEditorEditable from '../../hooks/useIsEditorEditable';
export function UnorderedListButton() {
  const { editor } = useCurrentEditor();
  const isEditable = useIsEditorEditable();
  if (!editor) return null;
  return (
    <div className="p-2">
      <Icon
        tooltip="Unordered List"
        tooltipProps={{
          delayDuration: 0,
        }}
        onClick={() => editor.chain().focus().toggleBulletListWithDefaultToken().run()}
        icon="list-ul"
        size="sm"
        selected={editor.isActive('bulletList')}
        disabled={!isEditable}
      />
    </div>
  );
}
export function OrderedListButton() {
  const { editor } = useCurrentEditor();
  const isEditable = useIsEditorEditable();

  if (!editor) return null;
  return (
    <div className="p-2">
      <Icon
        tooltip="Ordered List"
        tooltipProps={{
          delayDuration: 0,
        }}
        onClick={() => editor.chain().focus().toggleOrderedList().run()}
        icon="list-ol"
        size="sm"
        selected={editor.isActive('orderedList')}
        disabled={!isEditable}
      />
    </div>
  );
}
